/**
 * Course bonus content list.
 */
import React, { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import BEmpty from "components/BEmpty";
import { useAsterController } from "context";
import { VText } from "form";
import CourseBonusItem from "./course.bonus.item";

/**
 * Lists optional bonus units.
 */
const CourseBonus = () => {
  const { t } = useTranslation("common");

  const [controller] = useAsterController();
  const { structure, loadedCourseDetail } = controller;

  const [bonuses, setBonuses] = useState([]);

  useEffect(() => {
    if (structure.sections && loadedCourseDetail) {
      const arr = [];
      let key = 0;
      if (structure.sections && Array.isArray(structure.sections)) {
        const bonusIndex = structure.sections.findIndex((v) => v.section_title && /MODULE BONUS$/i.test(v.section_title));

        if (bonusIndex === -1) return;
        const bonus = structure.sections[bonusIndex];

        if (!bonus.sequences || !Array.isArray(bonus.sequences)) return;

        for (let seq of bonus.sequences) {
          if (!seq.verticals || !Array.isArray(seq.verticals)) continue;

          for (let vert of seq.verticals) {
            if (!vert.xblock_ids || !Array.isArray(vert.xblock_ids)) continue;

            for (let xblock of vert.xblock_ids) {
              if (xblock.type === "google-document" && xblock.raw_html) {
                arr.push({
                  display_name: xblock.display_name,
                  href: xblock.raw_html.match(/(https?:\/\/[^ ]*)"/)[1],
                  type: "PDF",
                  key: key++,
                });
              } else if (xblock.type === "videoxblock") {
                arr.push({
                  display_name: xblock.display_name,
                  href: `https://player.vimeo.com/video/${xblock.vimeo_id}`,
                  type: "VIDEO",
                  key: key++,
                });
              }
            }
          }
        }
      }

      setBonuses(arr);
    }
  }, [structure.sections, loadedCourseDetail]);

  return (
    <>
      <Box>
        <Box className="w-full flex justify-center sm:justify-start">
          <VText className="text-2xl font-bold">{t("Bonus")}</VText>
        </Box>

        {
          bonuses.length ? (
            <Box className="w-full my-5">
              <Box className="w-full my-8">
                <Grid container spacing={3} className="md:mt-2">
                  {bonuses.map((bonus) => (
                    <Grid item xs={12} sm={6} lg={4} key={bonus.key}>
                      <CourseBonusItem item={bonus} />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          ) :
          <BEmpty />
        }
      </Box>
    </>
  );
};

export default CourseBonus;
